import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/app/providers/AuthProvider";
import { isGlobalOwnerRole, resolveLegacyRole } from "@carmel/shared";

function resolveAdminRole(user: { role: string; primaryRoleId?: string | null }) {
  return user.primaryRoleId || resolveLegacyRole(user.role);
}

export function AdminRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-[var(--background)]">
        <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-[var(--color-primary)] border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const roleKey = resolveAdminRole(user);
  if (!roleKey || !isGlobalOwnerRole(roleKey)) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
